import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { SummaryActions } from '../summary/summary.ts';
import { AppActions } from '../app/app.ts';
import { RootState } from '../index.ts';

export const pushNotificationsListener = createListenerMiddleware();

pushNotificationsListener.startListening({
  matcher: isAnyOf(SummaryActions.setPensions, SummaryActions.setContributions, SummaryActions.setDebts),
  effect: async (_action, listenerApi) => {
    const state = listenerApi.getState() as RootState;

    const pensions = state.summary.pensions.data;
    const pensionsLoading = state.summary.pensions.loading;

    const idikaContributions = state.summary.contributions.data;
    const idikaLoading = state.summary.contributions.loading;

    const keaoContributions = state.summary.debts.data;
    const keaoLoading = state.summary.debts.loading;

    const hasPensions = !!(pensionsLoading || pensions?.pensionInfoList?.length);
    const hasContributions = !!(idikaLoading || idikaContributions?.contributions?.length);
    const hasDebts = !!(
      keaoLoading ||
      keaoContributions?.settledDebtsList?.length ||
      keaoContributions?.unsettledDebtsList?.length
    );

    listenerApi.dispatch(
      AppActions.setPushNotificationsTopics({
        hasPensions,
        hasContributions,
        hasDebts
      })
    );
  }
});
